import * as types from './types';

export const intacctLoginRequest = (data) => ({ type: types.INTACCT_LOGIN_REQUEST, data });
export const intacctLoginRequestFailure = (error) => ({ type: types.INTACCT_LOGIN_REQUEST_FAILURE, error });
export const intacctLoginRequestSuccess = (data) => ({ type: types.INTACCT_LOGIN_REQUEST_SUCCESS, data });

export const intacctSyncRequest = (data) => ({ type: types.INTACCT_SYNC_REQUEST, data });
export const intacctSyncRequestFailure = (error) => ({ type: types.INTACCT_SYNC_REQUEST_FAILURE, error });
export const intacctSyncRequestSuccess = (data) => ({ type: types.INTACCT_SYNC_REQUEST_SUCCESS, data });
export const intacctSyncRequestProgress = (data) => ({ type: types.INTACCT_SYNC_REQUEST_PROGRESS, data });

export const getSyncStatusRequest = (data) => ({ type: types.GET_SYNC_STATUS_REQUEST, data });
export const getSyncStatusRequestFailure = (error) => ({ type: types.GET_SYNC_STATUS_REQUEST_FAILURE, error });
export const getSyncStatusRequestSuccess = (data) => ({ type: types.GET_SYNC_STATUS_REQUEST_SUCCESS, data });

export const getCompanySyncStatusRequest = (data) => ({ type: types.GET_COMPANY_SYNC_STATUS_REQUEST, data });
export const getCompanySyncStatusRequestFailure = (error) => ({ type: types.GET_COMPANY_SYNC_STATUS_REQUEST_FAILURE, error });
export const getCompanySyncStatusRequestSuccess = (data) => ({ type: types.GET_COMPANY_SYNC_STATUS_REQUEST_SUCCESS, data });
